import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { createFilter } from 'react-select';

import { Flex } from 'reflexbox';
import {
  Text,
} from 'rebass';

import { SOCKET_TYPES } from 'shared/constants';
import {
  getGemInfo,
} from 'shared/gems';

import ReactSelect from './ReactSelect';
import WowIcon from './WowIcon';

const GemSelect = ({ gemId, socketType, includeUnique, label, onChange }) => {
  const gems = _.orderBy(_.filter(getGemInfo(), g => {
    if (g.unique && !includeUnique) {
      return false;
    }
    if (!g.expansion) {
      return false;
    }
    if (g.socketType === socketType) {
      return true;
    }
    return false;
  }), ['expansion', 'quality', 'craftingQuality'], ['desc', 'desc', 'desc']);

  const gemOptions = _.map(gems, g => ({
    value: String(g.itemId),
    label: (
      <Flex align="center">
        <WowIcon
          type="item"
          id={g.itemId}
          icon={g.itemIcon}
          quality={g.quality}
          size={20}
          noLink
        />
        <Text size={14} ml={1}>
          {g.name}
        </Text>
      </Flex>
    ),
    gem: g,
  }));

  return (
    <ReactSelect
      name="addSocket"
      label={label}
      value={_.find(gemOptions, { value: gemId })}
      onChange={option => {
        onChange(option.value);
      }}
      height={23}
      menuWidth={300}
      mb={0}
      options={[
        {
          value: '',
          label: '-- Select a gem --',
        },
        ...gemOptions,
      ]}
      // color={config.color}
      backgroundColor="#444"
      filterOption={createFilter({
        stringify: opt => {
          const gem = opt.data.gem;
          if (gem) {
            return _.join([gem.displayName, gem.itemName, gem.itemId], ' ');
          }
          return _.join([opt.label, opt.value], ' ');
        },
      })}
    />
  );
};

GemSelect.propTypes = {
  gemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  socketType: PropTypes.string,
  includeUnique: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

GemSelect.defaultProps = {
  gemId: null,
  socketType: SOCKET_TYPES.PRISMATIC,
  includeUnique: false,
  label: null,
  onChange: _.noop,
};

export default GemSelect;
